// Private-label caller group detection on the client side, from raw Keycloak realm roles
// (client sees `iris_vodafone_shop`; iris-server sees the proxy-mapped `ROLE_IRIS_VODAFONE_SHOP`).
// Used only for branding/assets — the authoritative room tag is derived server-side.
export const callerGroupFromRoles = (roles?: string[]): string | undefined => {
  if (!roles) return undefined
  if (roles.includes('iris_vodafone_shop') || roles.includes('ROLE_IRIS_VODAFONE_SHOP')) {
    return 'VODAFONE_SHOP'
  }
  return undefined
}
